import {callApi, getDefaultEditActions} from './helpers'

export const loadNitratiVirszemes = (query) => (dispatch) => {
    return dispatch(callApi({
      viewName: 'nitrati_virszemes_stacijas',
      crudMethod: 'listPaging',
      crudParam: query
    }))
}

export const NitratiVirszemesSelected = (id) => {
    return {
        type: 'nitrati_virszemes_stacijas_selected',
        payload: id
    }
}

export const reloadNitratiVirszemes = (id) => (dispatch, getState) => {
    return dispatch(callApi({
        viewName: 'nitrati_virszemes_stacijas',
        crudMethod: 'get',
        crudParam:  id ,
        success: (query) => {
          return dispatch(callApi({
            viewName: 'nitrati_virszemes_stacijas',
            crudMethod: 'save',
            crudParam: query,
            success: (result) => {
              dispatch(loadNitratiVirszemes(getState().location.query))
            }
          }))
        }
    }))
}

export const deleteNitratiVirszemes = (id) => (dispatch, getState) => {
  return dispatch(callApi({
    viewName: 'nitrati_virszemes_stacijas',
    crudMethod: 'delete',
    crudParam: id,
    success: (result) => {
      dispatch(loadNitratiVirszemes(getState().location.query))
    }
  }))
}

//pazemes stacijas
export const loadNitratiPazemes = (query) => (dispatch) => {
    return dispatch(callApi({
      viewName: 'nitrati_pazemes_stacijas',
      crudMethod: 'listPaging',
      crudParam: query
    }))
}

export const NitratiPazemesSelected = (id) => {
    return {
        type: 'nitrati_pazemes_stacijas_selected',
        payload: id
    }
}

export const reloadNitratiPazemes = (id) => (dispatch, getState) => {
    return dispatch(callApi({
        viewName: 'nitrati_pazemes_stacijas',
        crudMethod: 'get',
        crudParam:  id ,
        success: (query) => {
          return dispatch(callApi({
            viewName: 'nitrati_pazemes_stacijas',
            crudMethod: 'save',
            crudParam: query,
            success: (result) => {
              dispatch(loadNitratiPazemes(getState().location.query))
            }
          }))
        }
    }))
}

export const deleteNitratiPazemes = (id) => (dispatch, getState) => {
  return dispatch(callApi({
    viewName: 'nitrati_pazemes_stacijas',
    crudMethod: 'delete',
    crudParam: id,
    success: (result) => {
      dispatch(loadNitratiPazemes(getState().location.query))
    }
  }))
}

//eitrofikācijas robežvērtības
export const loadEitrofikacijasRobezvertibas = (query) => (dispatch) => {
    return dispatch(callApi({
      viewName: 'eitrofikacijas_robezvertibas',
      crudMethod: 'listPaging',
      crudParam: query
    }))
}

export const eitrofikacijasRobezvertibasSelected = (id) => {
    return {
        type: 'eitrofikacijasRobezvertibas_selected',
        payload: id
    }
}

const afterSaveOrDelete = (funk) => (dispatch, getState) => {
  dispatch(funk(getState().location.query))
}
export const eitrofikacijasRobezvertibasActions = getDefaultEditActions({
  actionTypeName: 'eitrofikacijasRobezvertibas',
  stateName: 'eitrofikacijasRobezvertibas',
  combinedPage: true,
  apiViewName: 'eitrofikacijas_robezvertibas',
  afterDelete: afterSaveOrDelete(loadEitrofikacijasRobezvertibas),
  afterSave: afterSaveOrDelete(loadEitrofikacijasRobezvertibas),
})
